<template>
  <div>
    <PageTitleBar
      v-if="!hide_title"
      parent="Institute Dashboard"
      title="Survey" 
      icon="fas fa-poll fa-2x mb-2 text-pink"
    />
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div v-else>

    <b-modal
        v-model="showPoGroupModal"
        title="Select PO Group"
        size="lg"
        hide-footer
      >

        <div v-if="fetchData" class="text-center">
          Loading...
        </div>

        <div v-else>
          <div v-for="group in pogroups.groups"
              :key="group.id"
              class="border rounded p-2 mb-2">

            <!-- GROUP HEADER -->
            <div class="d-flex align-items-center">
              <b-form-radio
                v-model="selectedPoGroupId"
                :value="group.id"
                class="mr-2"
              />
              <b><u>{{ group.name }}</u></b>
            </div>

            <!-- PO LIST -->
            <ul class="mt-2 pl-4">
              <li v-if="group.programme_outcomes.length < 1" class="text-danger">
                PO list is empty
              </li>

              <li v-for="po in group.programme_outcomes" :key="po.id">
                {{ po.code }} - {{ po.outcome }}
              </li>
            </ul>
          </div>

          <div class="text-right mt-3">
            <b-button variant="secondary" @click="showPoGroupModal = false">
              Cancel
            </b-button>

            <b-button variant="success" class="ml-2" @click="saveSurveyPoGroup">
              Save
            </b-button>
          </div>
        </div>

      </b-modal>

      <b-modal
        v-model="showPsoGroupModal"
        title="Select PSO Group"
        size="lg"
        hide-footer
      >

        <div v-if="fetchData" class="text-center">
          Loading...
        </div>

        <div v-else>
          <div v-for="group in psogroups.groups"
              :key="group.id"
              class="border rounded p-2 mb-2">

            <!-- GROUP HEADER -->
            <div class="d-flex align-items-center">
              <b-form-radio
                v-model="selectedPsoGroupId"
                :value="group.id"
                class="mr-2"
              />
              <b><u>{{ group.name }}</u></b>
            </div>

            <!-- PSO LIST -->
            <ul class="mt-2 pl-4">
              <li v-if="group.programme_specific_outcomes.length < 1" class="text-danger">
                PSO list is empty
              </li>

              <li v-for="pso in group.programme_specific_outcomes" :key="pso.id">
                {{ pso.code }} - {{ pso.outcome }}
              </li>
            </ul>
          </div>

          <div class="text-right mt-3">
            <b-button variant="secondary" @click="showPsoGroupModal = false">
              Cancel
            </b-button>

            <b-button variant="success" class="ml-2" @click="saveSurveyPsoGroup">
              Save
            </b-button>
          </div>
        </div>

      </b-modal>


      <b-modal id="surveyParticipants" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
        :title="participantsReportTitle" modal-class="usersListPendingFull">
        <SurveyParticipantReport :groupsWithSubgroupsOptions="groupsWithSubgroupsOptions"
          :survey_id="survey_id" :selectedSurveyType="survey_type" :coursesOptions="coursesOptions"
          :getCustomNames="getCustomNames" />
      </b-modal>

      <b-modal id="studentfeedbackModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
         modal-class="usersListPendingFull">
        <SurveyAnswers :survey_id="survey_id" />
      </b-modal>

      <b-modal id="HodSurveyAnswersModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
         modal-class="usersListPendingFull">
        <HodSurveyAnswers :survey_id="survey_id" />
      </b-modal>

      <b-modal id="AdvisorSurveyAnswersModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
         modal-class="usersListPendingFull">
        <AdvisorSurveyAnswers :survey_id="survey_id" />
      </b-modal>

       <b-modal id="infrastructurefeedbackModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
         modal-class="usersListPendingFull">
        <SurveyAnswersInfrastructure :survey_id="survey_id" />
      </b-modal>

      <b-modal id="SurveyAnswersCourseExitModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
         modal-class="usersListPendingFull">
        <SurveyAnswersCourseExit :survey_id="survey_id" />
      </b-modal>


      

      <b-modal id="downloadSurveyReport" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
        size="lg">
        <SurveyReportList :surveyReport="surveyReport" />
      </b-modal>
      <div class="mobileStudentView" v-if="$screenSize < 600">
        <SurveyMobileView :surveyAdmin="surveyAdmin" :surveyStudent="surveyStudent" :surveys="surveys" :today="today" />
      </div>
      <div class="surveys" v-else>
        <div class="surveyCreation" v-if="surveyForm">
          <CreatingSurveys @surveyCancelled="closeSurveyForm()" :surveyInfo="surveyInfo" />
        </div>
        <div class="surveyListing" v-else>
          <div class="p-2 d-flex justify-content-between" style="
              border: 2px solid #eeeeeb;
              border-left-style: none;
              border-right-style: none;
            ">
            <b-button ref="addCourse" size="sm" variant="info" v-if="surveyAdmin" @click="surveyForm = true"><i
                class="fas fa-plus-square text-white"></i>Add New Survey</b-button>
            <!-- <b-button
              class="ml-3"
              @click="openYoutubeLinks('Survey')"
              style="backgroundColor: #FF0000; border: none"
              size="sm"
            >
              <i class="fab fa-youtube"></i>
              Video Tutorial
            </b-button> -->
          </div>
          <div class="p-3" v-if="surveys.length != 0">
            <b-overlay :show="loadSurveyReport" spinner-variant="primary" spinner-type="grow" spinner-small
              rounded="md">
             
                <table class="table bordered table-bordered table-striped">
                  <thead class="thead-dark text-left">
                    <tr style="font-size: 14px; font-weight: 600">
                      <th>Name</th>
                      <th></th>
                      <th>Mode</th>
                      <th v-if="!surveyStudent"></th>
                      <th v-if="!surveyStudent"></th>
                      <th v-if="surveyAdmin"></th>
                      <th v-if="surveyAdmin"></th>
                      <th class="text-center" v-if="!surveyStudent">Questions</th>
                      <th>Created Date</th>
                      <th v-if="!surveyStudent">Created By</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th v-if="surveyAdmin"></th>
                      <th v-if="surveyStudent"></th>
                      <th v-if="!surveyStudent">Report</th>
                      <th>Academic year</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(survey, surveyIndex) in surveys" :key="surveyIndex"
                      style="font-size: 14px; font-weight: 600">
                      <td class="align-middle">
                        <div class="">
                          <span :id="'survey' + surveyIndex">{{ survey.name }}
                          </span>
                          <b-badge v-if="survey.survey_type == 'student_feedback'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="success">
                            Instructor Feedback Survey</b-badge>
                          <b-badge v-if="survey.survey_type == 'course_exit'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="danger">
                            Course Exit Survey</b-badge>
                          <b-badge v-if="survey.survey_type == 'programme_exit'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="warning">Programme
                            Exit Survey</b-badge>
                          <b-badge v-if="survey.survey_type == 'alumini'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="primary">
                            Alumini Survey</b-badge>
                          <b-badge v-if="survey.survey_type == 'employer'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="secondary">
                            Employer Survey</b-badge>
                          <b-badge v-if="survey.survey_type == 'parent'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="info">
                            Parent Survey</b-badge>
                          <b-badge v-if="survey.survey_type == 'faculty'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="dark">
                            Faculty Survey</b-badge>
                          <b-badge v-if="survey.survey_type == 'hod_feedback'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff; background-color: #8e44ad;" pill>
                            HOD Feedback Survey
                          </b-badge>
                          <b-badge v-if="survey.survey_type == 'class_advisors_feedback'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff; background-color: #16a085;"
                            pill>Class Advisors Feedback Survey</b-badge>
                          <b-badge v-if="survey.survey_type == 'infrastructure_feedback'"
                            style="font-size: 10px; font-weight: 600; color: #ffffff; background-color: #d35400;"
                            pill>Infrastructure Feedback Survey</b-badge>
                        </div>
                        <br />

                        <b-tooltip :target="'survey' + surveyIndex" triggers="hover" placement="topright">
                          <p style="font-size: 14px">{{ survey.summary }}</p>
                        </b-tooltip>
                      </td>
                      <td class="align-middle">
                        <span v-if="survey.course_id">
                          {{survey.course.code}}-{{ survey.course.usersubgroup.code }}-{{
                          survey.course.usersubgroup.usergroup.code }}
                        </span>
                        <span v-if="survey.usersubgroup && survey.usersubgroup.usergroup">
                          {{ survey.usersubgroup.code }} - {{ survey.usersubgroup.usergroup.code }}
                        </span>

                      </td>
                      <td class="align-middle">
                        <span v-if="survey.survey_mode == 'online'" class="bg-info p-1 rounded text-white m-0">
                          Online
                        </span>
                        <span v-if="survey.survey_mode == 'offline'" class="bg-info p-1 rounded text-white m-0">
                          Offline
                        </span>
                      </td>
                      <td class="align-middle" v-if="!surveyStudent">
                        <span 
                         style="cursor:pointer"
                         @click="openPoGroupPopup(survey)"
                         v-if="['programme_exit','alumini','employer','faculty','parent'].includes(survey.survey_type)">
                          <span v-if="survey.po_group_id && survey.group && survey.group.programme_outcomes"
                            class="text-primary">
                            {{ survey.group.programme_outcomes.length }} POs Added
                          </span>
                          <span v-else class="text-danger">
                            No POs mapped
                          </span>
                        </span>
                      </td>

                       <td class="align-middle" v-if="!surveyStudent">
                        <span 
                         style="cursor:pointer"
                         @click="openPsoGroupPopup(survey)"
                         v-if="['programme_exit','alumini','employer','faculty','parent'].includes(survey.survey_type)">
                          <span v-if="survey.pso_group_id && survey.psogroup && survey.psogroup.programme_specific_outcomes"
                            class="text-primary">
                            {{ survey.psogroup.programme_specific_outcomes.length }} PSOs Added
                          </span>
                          <span v-else class="text-danger">
                            No PSOs mapped
                          </span>
                        </span>
                      </td>

                      <td class="align-middle" v-if="surveyAdmin">
                        <b-button variant="primary" size="sm" squared v-if="survey.survey_mode == 'offline'"
                          @click="updateResult(survey.id)">Update Result</b-button>
                      </td>
                      <td class="align-middle text-nowrap" v-if="surveyAdmin">
                       <span
                          class="text-info btn m-0 p-0"
                          v-if="(
                              (['hod_feedback', 'class_advisors_feedback', 'infrastructure_feedback', 'student_feedback'].includes(survey.survey_type) && isInstitutionAdmin)
                              || !['hod_feedback', 'class_advisors_feedback', 'infrastructure_feedback', 'student_feedback'].includes(survey.survey_type)
                            )"
                          @click="getSurvey(survey.id)"
                        >
                          <i class="far fa-edit"></i>
                        </span>
                        <span
                          class="text-danger btn m-0 p-0 ml-2"
                          title="Delete Survey"
                          v-if="!survey.attended && (
                              (['hod_feedback', 'class_advisors_feedback', 'infrastructure_feedback', 'student_feedback'].includes(survey.survey_type) && isInstitutionAdmin)
                              || !['hod_feedback', 'class_advisors_feedback', 'infrastructure_feedback', 'student_feedback'].includes(survey.survey_type)
                            )"
                          @click="deleteSurvey(survey)"
                        >
                          <i class="far fa-trash-alt"></i>
                        </span>

                      </td>
                      <td class="align-middle text-center" v-if="!surveyStudent">
                        <div v-if="surveyAdmin">
                          <!-- <b-button variant="primary" size="sm" squared
                            @click="surveyLinks(survey.id, 'SurveyQues')">Add Ques</b-button> -->
                            <b-button
                              variant="primary"
                              size="sm"
                              squared
                              v-if="(
                                (['hod_feedback', 'class_advisors_feedback', 'infrastructure_feedback', 'student_feedback'].includes(survey.survey_type) && isInstitutionAdmin)
                                || !['hod_feedback', 'class_advisors_feedback', 'infrastructure_feedback', 'student_feedback'].includes(survey.survey_type)
                              )"
                              @click="surveyLinks(survey.id, 'SurveyQues')"
                            >
                              Add Ques
                            </b-button>

                          <!-- <b-button variant="primary" size="sm" class="ml-2" squared
                            @click="surveyLinks(survey.id, 'SurveyQuesExcel')">Import From Excel</b-button> -->
                        </div>
                      </td>
                      <td class="align-middle">{{ survey.created_at }}</td>
                      <td class="align-middle" v-if="!surveyStudent">
                        <span v-if="survey.creator">
                          {{ survey.creator.first_name }} {{ survey.creator.last_name || "" }}
                        </span>
                      </td>
                      <td class="align-middle">
                        <span v-if="survey.start_at_local.isValid()">
                          {{ survey.start_at_local.format("DD/MM/YYYY") }}</span>
                        <span v-else>Date not updated</span>
                      </td>
                      <td class="align-middle">
                        <span v-if="survey.end_at_local.isValid()">
                          {{ survey.end_at_local.format("DD/MM/YYYY") }}</span>
                        <span v-else>Date not updated</span>
                      </td>
                      <td class="align-middle" v-if="surveyAdmin">
                        <div :id="'hideSurvey' + surveyIndex" v-if="isInstitutionAdmin ||
                          !['class_advisors_feedback', 'hod_feedback', 'infrastructure_feedback', 'student_feedback']
                            .includes(survey.survey_type)"
                        >
                          <b-popover :target="'hideSurvey' + surveyIndex" triggers="hover">
                            {{
                            !survey.hidden
                            ? "This Survey is visible to students. Click to make it invisible."
                            : "This Survey is invisible to students. Click to make it visible."
                            }}
                          </b-popover>
                          <span v-if="!survey.hidden" @click="
                            hideSurvey(
                              survey.id,
                              true,
                              survey.name,
                              survey.academic_year
                            )
                          " class="btn p-0 m-0 text-info"><i class="far fa-eye"></i></span>
                          <span @click="
                            hideSurvey(
                              survey.id,
                              false,
                              survey.name,
                              survey.academic_year
                            )
                            " class="btn p-0 m-0 text-info" v-else><i class="fas fa-eye-slash"></i></span>
                        </div>
                      </td>

                      <td class="align-middle" v-if="surveyStudent">
                        {{ survey.survey_type }}
                        <b-button variant="primary" v-if="
                          today >= survey.start_at && today <= survey.end_at
                        " size="sm" pill @click="surveyLinks(survey.id, survey.survey_type)">Take Survey</b-button>
                        <span v-else-if="today <= survey.start_at" class="text-success">Upcoming Survey</span>
                        <span v-else class="text-danger">Last Date exceeded</span>
                      </td>
                      <td class="align-middle" v-if="!surveyStudent">

                        <!-- <span 
                          :id="'survey' + surveyIndex" v-if="survey.survey_type == 'hod_feedback'
                          || survey.survey_type == 'class_advisors_feedback'
                          || survey.survey_type == 'infrastructure_feedback'" 
                          class="btn p-0 m-0 text-info"
                          @click="getSurveyReports(survey.id, survey.name, survey.survey_type)">
                          <i class="fas fa-file-alt"></i>
                        </span> -->

                        <div v-if="survey.survey_type == 'student_feedback'">
                          <span 
                            v-if="selectedSurveyId !== survey.id" 
                            class="cursor-pointer" 
                            title="Download Survey Report"
                            @mouseover.once="openDownloadModal(survey)"
                          >
                            <i class="fas fa-file-alt text-info hover-effect"></i>
                          </span>
                          <DownloadSurveyReport v-else :survey="survey" />
                        </div>
                        <span 
                          :id="'survey' + surveyIndex" v-else-if="survey.survey_type == 'hod_feedback'
                          || survey.survey_type == 'class_advisors_feedback'
                          || survey.survey_type == 'infrastructure_feedback'" class="btn p-0 m-0 text-info"
                          @click="getSurveyReports(survey.id, survey.name, survey.survey_type, survey.usersubgroup_ids, survey.selected_usersubgroups)">
                          <i class="fas fa-file-alt"></i>
                        </span>


                        <div  v-else>
                        <span class="btn p-0 m--0 text-info"  v-if="survey.survey_type == 'programme_exit' || 
                        survey.survey_type == 'course_exit'"
                          @click="$bvModal.show('downloadCourseExitReportModel' + survey.id)"><i
                            class="fas fa-file-alt"></i></span>
                            <span class="btn p-0 m--0 text-info" v-if="survey.survey_type == 'alumini'
                              || survey.survey_type == 'employer' || survey.survey_type == 'parent' 
                              || survey.survey_type == 'faculty'"
                            @click="downloadCourseExitReport(
                              survey.id,
                              survey.name,
                              null,
                              survey.usersubgroup_id
                            )"><i class="fas fa-file-alt"></i></span>
                        <b-modal :id="'downloadCourseExitReportModel' + survey.id" title="Score Mapping"
                          no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer size="md">
                          <div class="table-responsive">
                            <div class="p-1 mt-3 border-secondary border-top"></div>
                            <b-button variant="primary" class="mb-2" size="sm" @click="addValue">+ Add Level</b-button>
                            <div class="table-responsive">
                              <table class="table table-bordered table-striped">
                                <thead class="thead-dark">
                                  <tr>
                                    <th>Value</th>
                                    <th>Comparison</th>
                                    <th>Compare By</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(attainment, attainmentIndex) in attainments" :key="attainmentIndex">
                                    <td class="align-middle">
                                      <b-form-input v-model.number="attainment.value"
                                        @keypress="handleNumber"></b-form-input>
                                    </td>
                                    <td class="align-middle">
                                      <b-form-select :options="operators"
                                        v-model="attainment.comparisan"></b-form-select>
                                    </td>
                                    <td class="align-middle">
                                      <b-form-input @keypress="handleNumber"
                                        v-model="attainment.compare_by"></b-form-input>
                                    </td>
                                    <td class="align-middle">
                                      <span class="btn p-0 m-0 text-danger"
                                        @click="attainments.splice(attainmentIndex, 1)">
                                        <i class="fas fa-minus-circle"></i>
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              <b-button variant="primary" class="mt-3" size="sm" @click="downloadCourseExitReport(
                                survey.id,
                                survey.name,
                                survey.course_id,
                                null
                              )"> Download PDF</b-button> <br><br>


                              <b-button size="sm" variant="primary"
                                v-if="survey.survey_type == 'course_exit' || survey.survey_type == 'programme_exit'"
                                @click="
                                  getParticipantsReport(
                                    survey.id, survey.survey_type
                                  )
                                  ">Participants Report</b-button>

                            </div>


                          </div>
                        </b-modal>
                        </div>
                      </td>
                      <td class="align-middle">
                        {{ survey.academic_year }}
                      </td>
                    </tr>
                  </tbody>
                </table>

            </b-overlay>
          </div>
          <div class="noSurveys" v-else>
            <p class="text-danger" v-if="surveyStudent">
              No Survey Exist now, check back later!
            </p>
            <p class="text-danger" v-else>No Surveys created yet!</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitleBar from "@/components/templates/Dashboard/Institute/PageTitleBar.vue";
import moment from "moment";
import CreatingSurveys from "./CreatingSurveys.vue";
import SurveyMobileView from "./SurveyMobileView.vue";
import acl from "../../../../authorization/acl.js";
import SurveyReportList from './SurveyReportList.vue'
import DownloadSurveyReport from "./DownloadSurveyReport.vue";
import SurveyAnswers from "@/components/templates/Dashboard/survey/SurveyAnswers.vue";
import HodSurveyAnswers from "@/components/templates/Dashboard/survey/HodSurveyAnswers.vue";
import AdvisorSurveyAnswers from "@/components/templates/Dashboard/survey/AdvisorSurveyAnswers.vue";
import SurveyAnswersCourseExit from "@/components/templates/Dashboard/survey/SurveyAnswersCourseExit.vue";
import SurveyAnswersInfrastructure from "@/components/templates/Dashboard/survey/SurveyAnswersProgramExit.vue";
import SurveyParticipantReport from '../reports/survey/SurveyParticipantReport.vue'
export default {
  props:["hide_title"],
  async created() {
    this.fetchData = true;
    const adminAccess = await acl.isUserGranted("surveyAdmin");
    this.surveyAdmin = adminAccess;
     const isInstitutionAdmin = await acl.isUserGranted(
      "editInstituitionSettings"
    );
    this.isInstitutionAdmin = isInstitutionAdmin;
    const studentAccess = await acl.isUserGranted("surveyStudent");
    this.surveyStudent = studentAccess;
    await this.getSurveys();
    await this.getGroupList();
    await this.getMyCourses();
  },
  components: {
    PageTitleBar,
    CreatingSurveys,
    SurveyMobileView,
    SurveyReportList,
    DownloadSurveyReport,
    SurveyParticipantReport,
    SurveyAnswers,
    HodSurveyAnswers,
    AdvisorSurveyAnswers,
    SurveyAnswersInfrastructure,
    SurveyAnswersCourseExit
  },
  data() {
    return {
      showPoGroupModal: false,
      showPsoGroupModal: false,
      currentSurvey: null,

      pogroups: { groups: [] },
      psogroups: { groups: [] },
      selectedPoGroupId: null,
      selectedPsoGroupId: null,

      surveyReport: {},
      participantsReportTitle: "",
      students: [],
      survey_type: "",
      survey_id: "",
      fetchData: false,
      loadSurveyReport: false,
      today: moment(),
      instructorSurveyAccess: null,
      surveyForm: false,
      surveys: [],
      surveyInfo: {},
      surveyAdmin: null,
      isInstitutionAdmin: false,
      surveyStudent: null,
      attainments: [
        { value: 1, comparisan: ">=", compare_by: 50 },
        { value: 2, comparisan: ">", compare_by: 65 },
        { value: 3, comparisan: ">", compare_by: 80 }
      ],
      operators: [
        { value: null, text: "Select Operator" },
        { value: "<", text: "<" },
        { value: ">", text: ">" },
        { value: "<=", text: "<=" },
        { value: ">=", text: ">=" },
      ],
      selectedSurveyId: null
    };
  },
  computed: {
    getCustomNames() {
      return this.$store.getters.getCustomNamings;
    },
  },
  methods: {
    async openPoGroupPopup(survey) {
      this.currentSurvey = survey;
      this.showPoGroupModal = true;
      this.selectedPoGroupId = survey.po_group_id ?? null;
      await this.getPoGroupsForSurvey(survey.usersubgroup.usergroup_id);
    },

    async getPoGroupsForSurvey(usergroupId) {
      this.fetchData = true;

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/po-groups?usergroup_id=${usergroupId}`;

      await this.$axios
        .get(url)
        .then(response => {
          this.pogroups = response.data;
        })
        .catch(() => {
          this.$toast.error("Failed to load PO groups");
        });

      this.fetchData = false;
    },

    async openPsoGroupPopup(survey) {
      this.currentSurvey = survey;
      this.showPsoGroupModal = true;
      this.selectedPsoGroupId = survey.po_group_id ?? null;
      await this.getPsoGroupsForSurvey(survey.usersubgroup.usergroup_id);
    },

    async getPsoGroupsForSurvey(usergroupId) {
      this.fetchData = true;

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/pso-groups?usergroup_id=${usergroupId}`;

      await this.$axios
        .get(url)
        .then(response => {
          this.psogroups = response.data;
        })
        .catch(() => {
          this.$toast.error("Failed to load PO groups");
        });

      this.fetchData = false;
    },

    async saveSurveyPoGroup() {
      if (!this.selectedPoGroupId) {
        this.$toast.error("Please select a PO group");
        return;
      }

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/studfbsurveys/${this.currentSurvey.id}/po-group`;

      await this.$axios
        .post(url, {
          po_group_id: this.selectedPoGroupId,
        })
        .then(() => {
          this.$toast.success("PO group saved");

          // update UI instantly
          this.currentSurvey.po_group_id = this.selectedPoGroupId;
          this.currentSurvey.group =
            this.pogroups.groups.find(
              g => g.id === this.selectedPoGroupId
            );

          this.showPoGroupModal = false;
        })
        .catch(() => {
          this.$toast.error("Failed to save PO group");
        });
    },

    async saveSurveyPsoGroup() {
      if (!this.selectedPsoGroupId) {
        this.$toast.error("Please select a PSO group");
        return;
      }

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/studfbsurveys/${this.currentSurvey.id}/pso-group`;

      await this.$axios
        .post(url, {
          pso_group_id: this.selectedPsoGroupId,
        })
        .then(() => {
          this.$toast.success("PSO group saved");

          // update UI instantly
          this.currentSurvey.pso_group_id = this.selectedPsoGroupId;
          this.currentSurvey.group =
            this.psogroups.groups.find(
              g => g.id === this.selectedPsoGroupId
            );

          this.showPsoGroupModal = false;
          this.getSurveys();
        })
        .catch(() => {
          this.$toast.error("Failed to save PSO group");
        });
    },

    async getParticipantsReport(surveyId, surveyType) {
      if (surveyType == "course_exit") {
        this.participantsReportTitle =
          "Participants Report for Course Exit Feedback";
      }
      if (surveyType == "programme_exit") {
        this.participantsReportTitle =
          "Participants Report for Programme Exit Feedback";
      }
      this.survey_id = surveyId;
      this.survey_type = surveyType;
      this.$bvModal.show("surveyParticipants");
    },

     getGroupList() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institutionuser/usersubgroups`;
      this.$axios
        .get(url)
        .then((response) => {
          let custom =
            +this.getCustomNames.userSubgroup.custom_name != null
              ? "Select " + this.getCustomNames.userSubgroup.custom_name
              : "Select Usersubgroup";
          this.groupsWithSubgroupsOptions = [
            { value: null, text: custom, code: null, disabled: true },
          ];
          this.usergroupOptions = [
            { value: null, text: custom, code: null, disabled: true },
          ];

          let groupSubgroup = response.data;

          if (this.surveyReport.type == 'infrastructure_feedback') {
            this.surveyReport.selected_usersubgroups = this.surveyReport.usersubgroup_ids;
          }
          groupSubgroup.forEach((subgroup) => {
            // Check if subgroup.id exists in selected_usersubgroups
            if (this.surveyReport.selected_usersubgroups.includes(subgroup.id)) {
              this.groupsWithSubgroupsOptions.push({
                value: subgroup.id,
                text: subgroup.usergroup.name + " - " + subgroup.name,
                code: subgroup.code + "-" + subgroup.usergroup.code,
              });
              this.usergroupOptions.push({
                value: subgroup.id,
                text: subgroup.usergroup.name + " - " + subgroup.name,
                code: subgroup.code + "-" + subgroup.usergroup.code,
              });
            }
          });


          response;
        })
        .catch((error) => {
          this.fetchData = false;
          error;
        });
    },
    getMyCourses() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institutionuser/courses/withusers`;
      this.$axios
        .get(url)
        .then((response) => {
          let courses = response.data;
          this.coursesOptions = [{ value: null, text: "Select Course" }];
          courses.forEach((course) => {
            this.coursesOptions.push({
              value: course.id,
              text:
                course.name +
                " (" +
                course.code +
                "-" +
                course.usersubgroup.usergroup.code +
                "-" +
                course.usersubgroup.code +
                ")",
            });
          });
          response;
        })
        .catch((error) => {
          error;
        });
    },
    openDownloadModal(survey) {
      this.selectedSurveyId = survey.id; 
    },
    getSurveyReports(id, name, type, usersubgroup_ids, selected_usersubgroups) {
      this.surveyReport.id = id;
      this.surveyReport.name = name;
      this.surveyReport.type = type;
      this.surveyReport.usersubgroup_ids = usersubgroup_ids, 
      this.surveyReport.selected_usersubgroups = selected_usersubgroups;
      this.$bvModal.show("downloadSurveyReport");
    },
    handleNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    addValue() {
      this.attainments.push({
        value: "",
        comparisan: null,
        compare_by: "",
      });
    },
    async downloadCourseExitReport(surveyId, surveyName, courseId,usersubgroupId) {
      const direct = [];
      await this.attainments.forEach((attainment) => {
        if (
          attainment.value != "" &&
          attainment.comparisan != null &&
          attainment.compare_by != ""
        ) {
          direct.push(attainment);
        }
      });
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/studfbsurveys/${surveyId}/report/pdfexport`;
      this.$axios
        .post(
          url,
          {
            rubrics: direct,
            course: courseId,
            usersubgroup: usersubgroupId,
          },
          { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", surveyName + ".pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.loadSurveyReport = false;
        })
        .catch(() => {
          this.loadSurveyReport = false;
        });
    },
    async getSurveys() {
      this.fetchData = true;
      const url = this.$store.getters.getAPIKey.studentFeedbackSurvey;
      await this.$axios
        .get(url)
        .then((response) => {
          this.surveys = [];
          const surveysData = response.data;
          surveysData.forEach((survey) => {
            if (this.surveyStudent && survey.hidden) {
              ("DO Nothing");
            } else {
              this.surveys.push({
                id: survey.id,
                name: survey.name,
                summary: survey.summary,
                course: survey.course,
                usersubgroup:survey.usersubgroup,
                academic_year: survey.academic_year,
                created_at: moment(survey.created_at).format("DD/MM/YYYY"),
                creator: survey.creator,
                start_at: moment(survey.start_at),
                start_at_local: moment(
                  moment.utc(survey.start_at, "YYYY-MM-DD HH:mm:ss").toDate()
                ),
                end_at: moment(survey.end_at),
                end_at_local: moment(
                  moment.utc(survey.end_at, "YYYY-MM-DD HH:mm:ss").toDate()
                ),
                comment_feedback: survey.comment_feedback == 0 ? false : true,
                is_anonymous: survey.is_anonymous == 0 ? false : true,
                hidden: survey.hidden,
                attended: !!survey.attended,
                time_required: survey.time_required,
                course_id: survey.course_id,
                usersubgroup_id: survey.usersubgroup_id,
                usersubgroup_ids: survey.usersubgroup_ids,
                survey_type: survey.survey_type,
                survey_mode: survey.survey_mode,
                po_group_id: survey.po_group_id,
                pso_group_id: survey.pso_group_id,
                group: survey.group,
                psogroup: survey.psogroup,
                selected_usersubgroups: survey.hods 
                  ? Array.from(new Set(survey.hods.map(hod => hod.subgroup_id))) 
                  : []
              });
            }
          });
          response;
        })
        .catch((error) => {
          error;
        });
      this.fetchData = false;
    },
    async getSurvey(surveyId) {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.studentFeedbackSurvey + `/${surveyId}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.survey = {};
          const surveyData = response.data;
          const date = [
            moment(
              moment.utc(surveyData.start_at, "YYYY-MM-DD HH:mm:ss").toDate()
            ).format("YYYY/MM/DD"),

            moment(
              moment.utc(surveyData.end_at, "YYYY-MM-DD HH:mm:ss").toDate()
            ).format("YYYY/MM/DD"),
          ];

          this.surveyInfo = {
            id: surveyData.id,
            name: surveyData.name,
            summary: surveyData.summary,
            academic_year: surveyData.academic_year,
            date: date,
            time_required: surveyData.time_required,
            grouping_tag: surveyData.grouping_tag,
            comment_feedback: surveyData.comment_feedback == 0 ? false : true,
            is_anonymous: surveyData.is_anonymous == 0 ? false : true,
            survey_type: surveyData.survey_type,
            survey_mode: surveyData.survey_mode,
            hidden: surveyData.hidden,
            course_id: surveyData.course_id,
            usersubgroup_id: surveyData.usersubgroup_id,
            usersubgroup_ids: surveyData.usersubgroup_ids,
          };
          this.surveyForm = true;
          response;
        })
        .catch((error) => {
          error;
        });
      this.fetchData = false;
    },
    async hideSurvey(surveyId, status, name, year) {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.studentFeedbackSurvey + `/${surveyId}`;
      await this.$axios
        .put(url, { hidden: status, name: name, academic_year: year })
        .then((response) => {
          let hiddenStatus = !status ? "Survey visible." : "Survey hidden.";
          this.$toast.success(hiddenStatus, {
            position: "top",
            duration: 3000,
          });
          this.getSurveys();
          response;
        })
        .catch((error) => {
          this.$toast.error("Something went wrong, Please try again!", {
            position: "top",
            duration: 3000,
          });
          this.fetchData = false;
          error;
        });
    },
    async deleteSurvey(survey) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Delete the survey "${survey.name}"? This cannot be undone.`,
        { title: "Delete Survey", okVariant: "danger", okTitle: "Delete", centered: true }
      );
      if (!confirmed) return;
      const url =
        this.$store.getters.getAPIKey.studentFeedbackSurvey + `/${survey.id}`;
      await this.$axios
        .delete(url)
        .then(() => {
          this.surveys = this.surveys.filter((s) => s.id != survey.id);
          this.$toast.success("Survey deleted.", { position: "top", duration: 3000 });
        })
        .catch((error) => {
          // attended after the list loaded: hide the delete icon now
          if (error.response && error.response.status == 422) survey.attended = true;
          const message =
            (error.response && error.response.data && error.response.data.message) ||
            "Something went wrong, Please try again!";
          this.$toast.error(message, { position: "top", duration: 3000 });
        });
    },
    closeSurveyForm() {
      this.getSurveys();
      this.surveyForm = false;
      this.surveyInfo = {};
    },
    surveyLinks(surveyId, type) {
      if (type == "SurveyQues") {
        let routeData = this.$router.resolve({
          name: type,
          params: {
            survey_id: surveyId,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        // this.$router.push({
        //   name: type,
        //   params: {
        //     survey_id: surveyId,
        //   },
        // });
        if (type == 'student_feedback') {
          this.survey_id = surveyId;
          this.$bvModal.show("studentfeedbackModal");
        }
        if (type == 'hod_feedback') {
          this.survey_id = surveyId;
          this.$bvModal.show("HodSurveyAnswersModal");
        }
        if (type == 'class_advisors_feedback') {
          this.survey_id = surveyId;
          this.$bvModal.show("AdvisorSurveyAnswersModal");
        }
        if (type == 'infrastructure_feedback' || type == 'programme_exit') {
          this.survey_id = surveyId;
          this.$bvModal.show("infrastructurefeedbackModal");
        }
        if (type == 'course_exit') {
          this.survey_id = surveyId;
          this.$bvModal.show("SurveyAnswersCourseExitModal");
        }  
      }

      // if (Link == "Questions") {
      //   this.$router.push({ path: `/survey_questions/${surveyId}` });
      // }
      // if (Link == "Answers") {
      //   if (type == "student_feedback") {
      //     this.$router.push({ path: `/survey_answers/${surveyId}` });
      //   }
      //   if (type == "course_exit") {
      //     this.$router.push({ path: `/survey_answers_course_exit/${surveyId}` });
      //   }
      //   if (type == "programme_exit") {
      //     this.$router.push({ path: `/survey_answers_programme_exit/${surveyId}` });
      //   }
      // }
      // if (Link == "Excel") {
      //   this.$router.push({ path: `/survey_questions_excel/${surveyId}` });
      // }
    },
    updateResult(surveyId) {
      let route = this.$router.resolve({
        path: `/survey_results/${surveyId}`
      });
      window.open(route.href, '_blank');
    }
  },
};
</script>

<style >
.surveyListing i {
  font-size: 12px !important;
  margin-right: 4px;
}

.usersListPendingFull .modal-dialog {
  max-width: 100%;
  max-height: 100%;
  margin: 0;
  padding: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed !important;
  z-index: 100000;
}

.usersListPendingFull .modal-content {
  border-radius: 0 !important;
  height: 100%;
  width: 100vw;
  max-height: 100%;
}

.usersListPendingFull .modal-body {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  flex: 1 1 auto;
  padding-bottom: 80px;
}

</style>